import React from "react";
import "./Terms.css";

const TermsJune_19 = () => {
  return (
    <div className="tandc-page">
      <div className="tandc">
        {/*  Page Heading */}
        <h3 className="page-title" align="center">
          Terms and Conditions
        </h3>
        {/* Heading */}
        <h3 className="page-sub-title" align="center">
          Thums Up® ThunderWheels 2026 Promotion
        </h3>
        {/* sub Heading */}
        <h3 className="page-sub-title" align="center">
          (1st June to 30th September 2026) - Current Promotion
        </h3>
        <h3 className="page-sub-title" align="center">
          The Campaign has been extended till 30th September 2026
        </h3>

        <div className="term-container">
          <div align="center">
            <table border="1" cellspacing="0" cellpadding="0" width="669">
              <tbody>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>Clause</strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Title</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      <strong>Terms and Conditions</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>1.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>
                        Promotion Details, Concept and Participation
                      </strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      <a name="_Hlk517722933">
                        <strong>Thums Up®</strong>{" "}
                      </a>
                      <strong>ThunderWheels 2026</strong>{" "}
                      <strong>Promotion</strong>
                      (“<strong>Promotion</strong>”) is a consumer promotion
                      organised by Coca-Cola India Private Limited (“
                      <strong>CCIPL</strong>”), wherein individuals, upon
                      scanning the QR Code on the Promotion Products (as defined
                      hereinbelow) can participate in and get a chance to win
                      Prize(s) (as defined in Clause 7) in accordance with the
                      terms and conditions mentioned herein. <strong></strong>
                    </p>
                    <p>
                      The Promotion shall be valid for the individuals residing
                      in India except for the states of Uttar Pradesh (excluding
                      Baghpat, Bulandshahar, Gautam Buddha Nagar, Ghaziabad,
                      Hapur, Meerut, Noida), Madhya Pradesh ( Gwalior, Morena,
                      Bhind, Sheopur, Datia only), Uttarakhand, Bihar and Tamil
                      Nadu (“
                      <strong>Promotion Territory”)</strong>
                      and shall be applicable on 250ml, 300ml, 350ml, 400ml,
                      500ml, 600ml, 740ml, 750ml, 1L, 1.25L, 1.5L, 2L, 2.25L,
                      2.5L Thums Up® PET packs
                      <strong>(“Promotion Product(s)”).</strong>
                      By participating in this Promotion, the Eligible Persons
                      as per Clause 5<strong>(</strong>
                      <strong>each a “Participant”)</strong>
                      accepts and agrees to abide by these terms and conditions
                      of the
                      <strong>Promotion (“Promotion Terms”).</strong>
                    </p>
                    <p>
                      It is hereby clarified that the Participant may
                      participate in the Promotion multiple times, but he/she
                      shall be eligible to win the “Prize(s)” as per Clause 7
                      during the Promotion Period.
                    </p>
                    <p>
                      The Promotion is advertised and promoted,
                      <em>inter alia</em>, through media including digital
                      media, point of sale materials, public announcements,
                      website, and other available media.
                    </p>
                    <p>
                      The Promotion is subject to all applicable central, state,
                      and local laws and regulations.
                    </p>
                    <p>
                      These Promotion terms and conditions (“
                      <strong>Terms</strong>”) will be hosted at{" "}
                      <a
                        style={{ textDecoration: "underline" }}
                        href="https://www.coke2home.com/thunderwheels/tandc"
                      >
                        https://www.coke2home.com/thunderwheels/tandc
                      </a>{" "}
                      (“<strong>Promotion Platform</strong>”).
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>2.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>CCIPL and Partners</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      This Promotion is organized by CCIPL, having its corporate
                      office at 16th floor, One Horizon Center, Golf Course
                      Road, DLF Phase V, Sector 43, Gurgaon.
                    </p>
                    <p>
                      <a>
                        The operational part of the Promotion is managed by
                        PREMIER SALES PROMOTIONS PRIVATE LIMITED, also known as
                        “<strong>BigCity</strong>”, a company governed under the
                        Companies Act, 1956 having its registered office at
                        Mitra Towers, 4 <sup>th</sup>
                        Floor, Kasturba Road, Bangalore 560 001
                      </a>
                      (hereinafter referred to as “<strong>Agency</strong>”).
                    </p>
                    <p>
                      CCIPL and the Agency may hereinafter be collectively
                      referred to as “<strong>Organiser</strong>”, as and where
                      applicable.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>3.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Deemed acceptance of terms and conditions</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      Entry and participation in this Promotion will be deemed
                      unconditional and an unequivocal acceptance of these
                      Terms, including any modifications, revisions, and
                      amendments thereto. The decisions of CCIPL shall be final
                      and binding on the Participants in all matters related to
                      the Promotion. Further, the Participants recognize that
                      these Terms may be modified by CCIPL from time to time
                      without any prior/public notice by posting the applicable
                      terms and conditions on the Promotion Platform. CCIPL also
                      reserves the right to cancel or terminate the Promotion at
                      any stage without assigning any reasons whatsoever.
                      Successfully entering the Promotion and winning a Prize is
                      subject to all requirements set forth herein.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>4.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Promotion Period</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      <a name="_Hlk95730028"></a>
                      <a>This Promotion will</a>commence at 00:00:00 hrs Indian
                      Standard Time (“<strong>IST</strong>”) on{" "}
                      <strong>
                        1<sup>st</sup> June 2026
                      </strong>{" "}
                      (“Start Date”) and will continue until{" "}
                      <strong>
                        30<sup>th</sup> September 2026{" "}
                      </strong>
                      <strong>11:59:59 pm IST</strong> (“End Date”) (“
                      <strong>Promotion Period</strong>”). Participation will
                      only be allowed during <strong>9AM-10PM IST</strong> daily
                      (“<strong>Daily Promotion Window”</strong>). Any entries
                      received outside the Daily Promotion Window and the
                      Promotion Period shall not be eligible for the Prize(s)
                      applicable for that phase and shall not be carried forward
                      to any other promotional scheme ahead.
                    </p>
                    <p>
                      Stock of The Coca-Cola Company Products without the
                      Promotion offer will also be available across India.
                    </p>
                    <p>
                      Further, certain stock of The Coca-Cola Company Products
                      containing the Promotion offer may be available before the
                      Promotion Period or may continue to be available even
                      after the Promotion Period. However, prospective
                      Participants understand and agree that they will not be
                      permitted to participate in the Promotion before
                      commencement of the Promotion Period and after the expiry
                      of the Promotion Period and further, agree not to raise
                      any claim or complaint against CCIPL, its affiliates or
                      its agents in this respect.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>5.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Eligibility</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      Subject to the criteria of Promotion Territory, entry and
                      participation in this Promotion is open to individuals who
                      satisfy each of the following criteria (“
                      <strong>Eligible Persons</strong>”):
                    </p>
                    <ol start="1" type="i">
                      <li>Must have attained 18 (eighteen) years of age.</li>
                      <li>
                        Possess a valid mobile phone number registered with an
                        active SIM Card.
                      </li>
                      <li>
                        Bear a good moral character and have not been implicated
                        or named in any legal proceedings (either civil or
                        criminal).
                      </li>
                      <li>
                        Are not management, employees, directors or contractors,
                        or the family of the management, employees, directors or
                        contractors of CCIPL, their related entities or other
                        agencies, firms or companies associated with or related
                        to the Promotion (including suppliers of Prizes).
                      </li>
                    </ol>
                    <p>
                      Please note that any entry received from states other than
                      the Promotion Territory shall be declared as null and void
                      and shall not be taken into consideration for determining
                      the Winners of the Prize.
                    </p>
                    <p>
                      For the sake of clarity, this Promotion is not open to
                      Non-Resident Indians (NRIs), Overseas Citizens of India
                      (OCIs) and Persons of Indian Origin (PIOs).
                    </p>
                    <p>
                      Eligible Persons participating or seeking to participate
                      in the Promotion shall individually be referred to as “
                      <strong>Participant</strong>” and collectively as “
                      <strong>Participants</strong>”.
                    </p>
                    <p>
                      If any Eligible Person has listed his/her phone numbers on
                      the National Do Not Call Registry (“
                      <strong>NDNC Registry</strong>”), he/she shall de-register
                      from the NDNC Registry prior to participating in the
                      Promotion, till the completion of the Promotion (including
                      availing of the Prize (if applicable) under the
                      Promotion). Such persons agree not to make any claim or
                      raise any complaint whatsoever against CCIPL in this
                      respect. Please note that persons intending to participate
                      in the Promotion who have not de-registered themselves
                      from the NDNC Registry shall also have no right to make
                      any claim or raise any complaints against CCIPL, if they
                      do or do not receive any call or SMS with respect to their
                      application, participation and all other matters
                      pertaining to the Promotion.
                    </p>
                    <p>
                      By participating in the Promotion, each Participant hereby
                      agrees to receive:
                    </p>
                    <p>
                      i. details and information on this Promotion, on their
                      respective mobile phones, through SMS or voice calls,
                      WhatsApp, during the entire tenure of the Promotion.
                    </p>
                    <p>
                      ii. updates and announcements concerning CCIPL’s products
                      and promotions, on their respective mobile phones (through
                      SMS or voice calls or WhatsApp) and Email Ids.{" "}
                      <strong></strong>
                    </p>
                    <p>
                      <strong>(“Marketing Communication”)</strong>
                    </p>
                    <p>
                      The Participant may opt-out of receiving Marketing
                      Communication from CCIPL at any time by emailing or
                      calling, using the contact information listed below. In
                      such a request, the Participant must indicate that he/she
                      wishes to stop receiving Marketing Communication from
                      CCIPL.
                    </p>
                    <p>
                      Email:
                      <a href="mailto:indiahelpline@coca-cola.com">
                        {" "}
                        indiahelpline@coca-cola.com
                      </a>
                    </p>
                    <p>Consumer Helpline: 1800-208-2653</p>
                    <p>Timings:</p>
                    <p>9:00am–9:00pm (Mon-Sat)</p>
                    <p>9:00am-6:00pm (Sun)</p>
                    <p>
                      The Participant hereby agrees that he/she has read and
                      understood the Privacy Policy mentioned on the Promotion
                      Platform and provides his/her unconditional consent to
                      collection of his/her personal information namely Name,
                      Mobile Number, Email ID, Address and Location. Further,
                      the Participant hereby provides his/her consent for
                      storage and processing of his/her personal information
                      collected for the purposes of sending communication
                      including but not limited to Marketing Communication.
                    </p>
                    <p>
                      <strong></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>6.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Participating in the Promotion</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      <a>
                        The Participant can participate subject to the following
                        terms:
                      </a>
                    </p>
                    <p>1. Buy a Thums Up® Promotion Product</p>
                    <p>
                      2. Scan QR code on Promotion Product to visit Thums Up®
                      official WhatsApp Channel (“Platform”).
                    </p>
                    <p>
                      3. Press ‘Send’ on the autotyped message on the Thums Up®
                      WhatsApp channel to begin the conversation with the Thums
                      Up® WhatsApp chatbot. A link to these Terms &amp;
                      Conditions and the Privacy Policy will be made available
                      here as well. By continuing in the conversation,
                      Participants are deemed to have consented to the Terms and
                      Conditions, and to the collection, storage and processing
                      of their personal information as per the Privacy Policy
                      provided therein.
                    </p>
                    <p>
                      4. Engage with the WhatsApp chatbot, select your State of
                      participation, and add unique code from behind the label
                      of the Promotion Product.
                    </p>
                    <p>
                      5. Upon entering a valid unique code during the
                      <a>Daily Participation Window within the</a>
                      Promotion Period, the Participant shall be eligible to
                      enter the computerized random draw for a chance to win the
                      Prize(s) in accordance with Clause 7.
                    </p>
                    <p>
                      6. If the Participant gets selected as a Winner of the
                      Daily Prize(s), they will be notified on the Platform on
                      the win, along with voucher code and instructions to
                      redeem the Prize.
                    </p>
                    <p>
                      7. Additional terms and conditions may apply on the
                      redemption platforms.
                    </p>
                    <p>
                      8. If the Participant gets selected as a Winner of the
                      Bumper Prize, they will be notified on the Platform of the
                      win.
                    </p>
                    <p>
                      9. The Participant will be required to fill out a Claim
                      Form to provide, including but not limited to, their
                      shipping address.
                    </p>
                    <p>Additional Terms</p>
                    <p>
                      (i) Daily Prize(s) must be redeemed latest by 10
                      <sup>th</sup> December 2026 using the voucher details and
                      link shared <a></a>
                      <a>on the Platform</a>. Any Daily Prize(s) not claimed by
                      this date will be forfeited.
                    </p>
                    <p>
                      (ii) Bumper Prize must be claimed using a claim form
                      available on the Platform
                      <strong>within 72 hours</strong>
                      of winning the Prize (“<strong>Claim Window</strong>”) to
                      avoid forfeiting.
                    </p>
                    <p>
                      (iii) All earned Prize(s) will be visible under ‘My Wins’
                      Section on the Promotion WhatsApp Chatbot.
                    </p>
                    <p>
                      (iv) Prizes must be redeemed within the Promo period and
                      within the timeframe during each step
                      <strong>(“Redemption Window”)</strong>. Any Prize not
                      claimed by the Redemption Window will be forfeited.
                    </p>
                    <p>
                      (v) Participants may participate any number of times to
                      get a chance to win the Prize(s), however, it is clarified
                      that each Participant will be eligible to win as per
                      Clause 7.
                    </p>
                    <p>
                      (vi) Participants will also be notified via WhatsApp of
                      the details of the Prize(s) won &amp; instructions on how
                      to redeem their Prize(s).
                    </p>
                    <p>
                      (vii) Any forfeiture exercised will be binding and final
                      on the participants.
                    </p>
                    <p>
                      (viii) Entry by proxy is not permitted. Participants can
                      only enter in their own name. The Participants shall be
                      solely responsible for any local calls / STD charges
                      applicable by their telecom service providers on the
                      Promotion entries.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>7.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Prizes and Winners</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      During the Promotion Period, Participants on the basis of
                      valid participation as per the Terms of Clause 6, shall
                      get a chance to win the following Prize(s):
                    </p>
                    <p>
                      <a>
                        <strong>
                          <u>
                            Daily Prize (Twice per Mobile Number during the
                            Promotion Period):
                          </u>
                        </strong>
                      </a>
                    </p>
                    <p>I. PhonePe Cashback worth up to Rs.100/-</p>
                    <p>
                      <strong>
                        <u>
                          Bumper Prize (Once per Mobile Number during the
                          Promotion Period):
                        </u>
                      </strong>
                    </p>
                    <p>
                      I. One (1) motorcycle of at least 250CC engine capacity.
                    </p>
                    <p>
                      The exact make, model, variant, colour, and specifications
                      of the Bike Prize shall be determined by CCIPL at its sole
                      discretion and communicated to Winners at the time of
                      Prize fulfilment.
                    </p>
                    <p>
                      <a>
                        <strong>Additional Terms for the Bumper Prize:</strong>
                      </a>
                    </p>
                    <p>
                      1. The Winners of the Bumper Prize, upon submission of
                      valid Claim Form on the Platform, shall be contacted by
                      the authorised Agency of CCIPL via email, confirming the
                      Winner and their Bumper Prize.
                    </p>
                    <p>
                      2. The Winner is required to show said email confirming
                      his/her winnings to the designated dealership or
                      collection point (as defined herein below) to claim the
                      Bumper Prize, subject to the below terms.
                    </p>
                    <p>
                      3. The Winner must have a valid Indian driving licence.
                    </p>
                    <p>
                      4. The Winner, subject to submission of valid documents as
                      needed and communicated to the Winner by CCIPL/Agency,
                      shall be required to collect the Bumper Prize from the
                      designated dealership or collection point as nominated by
                      CCIPL or its authorised bike partner (and communicated to
                      the Winner by the Agency) ("Designated Collection Point")
                      within the timeframe communicated by CCIPL/Agency ("
                      <strong>Bike Prize Redemption Window</strong>”).
                    </p>
                    <p>
                      5. No claim for a Bumper Prize may be entertained by CCIPL
                      outside the Bike Prize Redemption Window or when all
                      requested documents are not submitted.
                    </p>
                    <p>
                      6. It is hereby clarified that the Designated Collection
                      Point may not be in the same city where the Winner is
                      residing and in the event the Designated Collection Point
                      is in a different city, neither the Agency, the bike
                      partner, nor CCIPL shall be responsible for undertaking
                      any travel and/or transportation cost for the Winner to
                      travel to or from such Designated Collection Point, or for
                      the transport of the Bumper Prize.
                    </p>
                    <p>
                      7. The Winner shall be solely responsible for making any
                      payments on the Bumper Prize, including but not limited to
                      RTO charges, handling charges, road tax, insurance,
                      registration, and pollution certificate upon transfer of
                      ownership and possession of the Bumper Prize from the bike
                      partner/manufacturer to the Winner.
                    </p>
                    <p>
                      8. Any requirements of servicing of the Bumper Prize shall
                      lie with the bike manufacturer/partner as per its standard
                      warranty terms applicable to the motorcycle provided.
                      CCIPL shall not be liable for the same.
                    </p>
                    <p>
                      The delivery of the Bumper Prize to the Winner shall be
                      subject to the bike partner’s/manufacturer’s terms and
                      privacy policy as available on its website; submission of
                      relevant documents; other payments as reflected above in
                      Clause 7 (6); and applicable laws.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>8.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Selecting and contacting Eligible Winners</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      (i) The Participants will be eligible to receive the Prize
                      subject to the Terms detailed herein.
                    </p>
                    <p>
                      (ii) Winners will be selected through a computerized
                      random selection from the pool of valid submissions/
                      entries, in accordance with these Terms &amp; Conditions.
                    </p>
                    <p>
                      (iii) The Participants acknowledge not to raise any claim
                      or complaint against CCIPL due to technical failure or any
                      other causes beyond the control of CCIPL.
                    </p>
                    <p>
                      (iv) Prizes once awarded cannot be replaced under any
                      circumstances.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>9.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Conditions relating to the Prize</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      (i) CCIPL shall not be held responsible for any
                      deficiency, defect, inadequacy, or irregularity in the
                      Prize(s).
                    </p>
                    <p>
                      (ii) The Winner(s) may not exchange or assign the Prizes
                      and shall not be entitled to any compensation whether in
                      cash or kind from CCIPL.
                    </p>
                    <p>
                      (iii) No portion of the Prizes offered under the Promotion
                      is redeemable for cash or kind from CCIPL. The Prizes are
                      also not refundable or transferable and cannot be
                      exchanged.
                    </p>
                    <p>
                      (iv) No Prize will be awarded if the information presented
                      by the Participant(s) at the time of entering the
                      Promotion, or at any subsequent stage, is factually
                      incorrect.
                    </p>
                    <p>
                      (v) In the event of death of the Winner, no claim from the
                      nominee or his/her legal heirs of the Winner shall be
                      entertained for receiving the Prize.
                    </p>
                    <p>
                      (vi) Prize shall be provided to the Winners on an "as-is
                      basis" and without any warranty or guarantee concerning
                      the quality, suitability or comfort, and CCIPL and/or its
                      associates, affiliates and/ or its management, directors,
                      officers, agents, representatives shall not be responsible
                      for or liable (including but not limited to the product
                      and service liabilities) for deficiency and/ or defect of
                      any product/service and/or the Prize or for any kind of
                      consequential damages/ loss, in any manner whatsoever. The
                      guarantee and warranty of the Prizes shall be transferred
                      to the Winners as received from the Manufacturer /
                      Distributor.
                    </p>
                    <p>
                      (vii) If a Participant has any grievance with respect to
                      the Prize, he/she may directly contact the manufacturer.
                    </p>
                    <p>
                      (viii) The image of the Prize depicted on the press
                      ads/posters/TVC's/pack shots etc. are for illustrative
                      purposes only and the actual Prize may vary from the
                      depiction made.
                    </p>
                    <p>
                      (ix) It is to be noted that in the event the Winner does
                      not take the Prize in the time and manner stipulated, then
                      the Prize shall be forfeited by the Winner and cash or any
                      monetary benefits in kind shall not be awarded in lieu of
                      the Prize. Prizes must be taken as offered and cannot be
                      varied.
                    </p>
                    <p>
                      (x) Special Conditions for Bike Prize: The Winner of the
                      Bike Prize must: (a) be at least 18 years of age and
                      possess a valid driving license to ride a motorcycle at
                      the time of claiming the Prize; (b) bear all costs related
                      to registration, insurance, road tax, RTO charges,
                      handling charges, and any other statutory or incidental
                      charges associated with the Bike Prize; and (c) provide
                      all documentation required for vehicle registration in the
                      Winner’s name. The Bike Prize shall be delivered to a
                      location determined by CCIPL/Agency, and the Winner shall
                      be responsible for collection and transportation from such
                      location. The Bike Prize does not include accessories,
                      helmets, or any add-ons unless expressly stated.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>10.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Publicity</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      The Participants undertake and irrevocably and
                      unconditionally permit CCIPL to cover the Promotion
                      through various media including newspapers, radio,
                      television including news and other channels, internet,
                      point of sale materials, etc., and shall not raise any
                      objection, protest, or demur whatsoever to such coverage
                      or in this regard. Further, the Participants also
                      understand and agree that their responses may be
                      publicised as part of this Promotion.
                    </p>
                    <p>
                      The Winners must, at the request of CCIPL, participate in
                      all promotional activity (such as publicity and
                      photography) surrounding the winning of the Prize, free of
                      charge, and they consent to CCIPL using their name and
                      image in all promotional materials.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>11.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Intellectual Property</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      All right, title, and interest, including but not limited
                      to the Intellectual Property Rights, in the promotional
                      material(s), and in any and all responses received, or
                      other materials created during or for the Promotion, as a
                      part of the Promotion or otherwise, shall vest solely and
                      exclusively with CCIPL at all times. CCIPL or any person
                      or entity permitted by CCIPL in this regard shall be
                      entitled to use any information in connection with the
                      entry in any media for future promotional, marketing,
                      publicity and any other purpose, without any permission
                      and or payment to the Participant. CCIPL may use the
                      material in any medium in any reasonable manner it sees
                      fit. Copyright in any such material remains the sole
                      property of CCIPL.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>12.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>General Conditions</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      <strong>
                        <u>General Terms and Conditions:</u>
                      </strong>
                    </p>
                    <ul>
                      <li>
                        Each Participant represents and warrants that he/she is
                        legally competent to enter into binding contracts under
                        applicable laws. By taking part and/or entering into the
                        Promotion the Participant warrants that all information
                        provided by Participant regarding Participant's name,
                        age, state, city, address, phone number, etc., is true,
                        correct, accurate and complete.
                      </li>
                      <li>
                        The decision of the Organiser, as regards the selection
                        of winners and distribution of the prizes shall be
                        final, subject only to CCIPL ‘s approval. No
                        correspondence or any other claims whatsoever, in this
                        regard will be entertained.
                      </li>
                      <li>
                        No queries, claims, dispute, complaints or grievances
                        shall be entertained by the Organiser after 30 days from
                        the date of the closure of the Promotion.
                      </li>
                      <li>
                        The prize cannot be exchanged and is not transferable
                        and cannot be converted into cash.
                      </li>
                      <li>
                        The Agency shall provide the prize on an "as-is basis"
                        and without any warranty or guarantee concerning the
                        quality, suitability or comfort, and CCIPL and/or its
                        associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever.
                      </li>
                      <li>
                        CCIPL reserves the right to change, defer, alter or
                        cancel this Promotion in part or full, or change any or
                        all of the terms and conditions that are applicable,
                        without giving prior intimation/notice of any kind and
                        will not be liable for any consequential losses/damages.
                        Any decision of CCIPL in this regard and in general with
                        respect to this Promotion and the terms and conditions
                        thereto shall be final, binding and non-contestable.
                      </li>
                      <li>
                        Nothing contained herein amounts to a commitment or
                        representation by CCIPL to conduct further Promotion.
                      </li>
                      <li>
                        CCIPL reserves the right to change any details of the
                        Promotion, including but not limited to amending these
                        terms and conditions, the type of Promotion, submission
                        mechanism, eligibility criteria, term of the Promotion,
                        and the prizes for the Promotion. CCIPL reserves the
                        right to amend, temporarily suspend or withdraw the
                        Promotion in its absolute discretion provided that CCIPL
                        shall not exercise this right unreasonably.
                      </li>
                      <li>
                        CCIPL shall not be liable to award/provide the prize(s)
                        and/or declare the winners of the prizes of the
                        Promotion due to any cause beyond its reasonable control
                        or foresight, including but not limited to, act of god,
                        insurrection or civil disorder, religious strife, war or
                        military operations, terrorist act, partial or total
                        strikes, either internal or external, lock-out,
                        epidemic, blockage of means of transport or of supplies,
                        national or local emergency, earthquake, fire, storm,
                        flood, water damage, governmental, regulatory or legal
                        restrictions, acts or omissions of persons for whom
                        CCIPL is not responsible.
                      </li>
                      <li>
                        The decision of CCIPL shall be final in all regards and
                        no communication shall be entertained in this regard.
                        None of the provisions of these Terms and Conditions
                        shall be deemed to constitute a partnership or agency
                        between any Participant and CCIPL and the Participant
                        shall not have the authority to bind CCIPL in any manner
                        whatsoever.
                      </li>
                      <li>
                        CCIPL or any of its respective
                        officers/employees/directors shall not be responsible
                        for delayed, lost, mutilated, corrupted or illegible
                        documents etc.
                      </li>
                      <li>
                        The Organiser shall not be liable to perform any of
                        its/their respective obligations under the Promotion or
                        in respect of the prize where it is unable to do so as a
                        result of circumstances beyond its/their control in the
                        nature of fire, explosions, natural calamities, state
                        emergency, riots, or any other Force Majeure condition,
                        etc., and shall not be liable to compensate the
                        Participant in these circumstances.
                      </li>
                      <li>
                        The Organiser shall not be accountable/liable for any
                        disruptions/stoppages/interruptions or cancellation of
                        the Promotion due to any government restrictions.
                      </li>
                      <li>
                        Failure to exercise or delay in exercising a right or
                        remedy provided hereunder or by law does not constitute
                        a waiver of the right or remedy or waiver of other
                        rights or remedies on the part of The Organiser.
                      </li>
                      <li>
                        The Organiser accepts no responsibility for late, lost,
                        incomplete, incorrectly submitted, delayed, illegible,
                        corrupted or misdirected entries, loss of SMS, loss of
                        internet connectivity, unique codes, documents, demand
                        drafts, claims or correspondence whether due to error,
                        omission, alteration, tampering, unauthorized data
                        hacking, deletion, theft, destruction, virus attack,
                        transmission interruption, communications failure,
                        hardware failure or otherwise. The Organiser shall not
                        be liable for any consequences of user error including
                        (without limitation) costs incurred.
                      </li>
                      <li>
                        If a Participant is dissatisfied with the Promotion or
                        the Promotion rules and/or any content or any
                        requirements of the Promotion form, the materials
                        available related thereto, or with these terms and
                        conditions, his/her sole and exclusive remedy is to not
                        participate in the Promotion.
                      </li>
                      <li>
                        If a person chooses to access the Promotion Platform
                        from outside India, he/she shall do so on his/her own
                        initiative and shall be responsible for compliance with
                        applicable local laws of the country.
                      </li>
                      <li>
                        The operational part of the scheme like redemption of
                        prize &amp; dispatches shall be managed by the Agency;
                        However, promotional product will be distributed through
                        CCIPL Distributor/dealer.
                      </li>
                      <li>
                        The participation in the Promotion is purely voluntary
                        and the same shall be construed as an acceptance of the
                        terms and conditions stipulated herein.
                      </li>
                      <li>Release and Limitations of Liability:</li>
                    </ul>
                    <p>
                      (i) CCIPL, the Agency and the Logistics Partner shall
                      under no circumstances be liable, whether jointly or
                      severally, for any loss or damage suffered or sustained
                      (including but not limited to consequential loss),
                      including for personal injury or property damage suffered
                      or sustained, as a result of acceptance of any prize.
                    </p>
                    <p>
                      (ii) By entering the Promotion, the Participant hereby
                      releases from and agrees to indemnify CCIPL, and/ or any
                      of its respective officers/employees from and against all
                      liability, cost, loss or expense arising out of acceptance
                      of the prize or participation in the Promotion including
                      (but not limited to) personal injury and damage to
                      property and whether direct, indirect, consequential,
                      foreseeable, due to some negligent act or omission, or
                      otherwise.
                    </p>
                    <p>
                      (iii) The Organiser accept no liability, whether jointly
                      or severally, for any errors or omissions, whether on
                      behalf of itself, Agency or third parties in relation to
                      the prizes.
                    </p>
                    <p>
                      (iv) The Participant shall be solely responsible for any
                      consequences which may arise due to his/her participation
                      in the Promotion by conducting an illegal act. Participant
                      also undertakes to indemnify CCIPL and/or the Agency and
                      their respective officers, directors, employees and agents
                      on the happening of such an event (including without
                      limitation cost of attorney, legal charges etc.) on full
                      indemnity basis for any loss/damage suffered by The
                      Organiser on account of such act on the part of the
                      Participant.
                    </p>
                    <p>
                      (v) In consideration of CCIPL allowing the Participant(s)
                      to take part in the Promotion , to the maximum extent
                      permitted by law, the Participant(s) waive and release
                      each and every right or claim, all actions, causes of
                      actions (present or future) each of them has or may have
                      against CCIPL , its respective agents, directors,
                      officers, business associates, group companies, sponsors,
                      employees, or representatives for all and any injuries,
                      accidents, or mishaps (whether known or unknown) or
                      (whether anticipated or unanticipated) arising out of the
                      Promotion or related to the Promotion or the prize of the
                      Promotion.
                    </p>
                    <ul>
                      <li>Additional General Terms and Conditions</li>
                    </ul>
                    <p>
                      o This Promotion is not available to employees, of the
                      Organiser, its clients or agencies and their immediate
                      families.
                    </p>
                    <p>
                      o Any costs associated with entering the Promotion,
                      including accessing the Promotion Platform, are the
                      responsibility of each Participant. Also, regular call and
                      message rates will apply as per the consumer telecom
                      operator in their respective circles.
                    </p>
                    <p>
                      o The Agency is acting as an executing agency for this
                      Promotion and holds no legal and financial liability on
                      unclaimed Prize (s), incentives, etc. beyond the
                      applicable period of the Promotion.
                    </p>
                    <p>
                      o This Promotion is subject to promotional availability
                      and government regulations.
                    </p>
                    <p>
                      o The Organiser reserves the right to change the terms and
                      conditions of this scheme, including extending,
                      withdrawing, or discontinuing the same without notice,
                      without assigning any reason, at their sole discretion and
                      without any liability.
                    </p>
                    <p>
                      o If this promotion is interfered with in any way or is
                      not capable of being conducted as reasonably anticipated
                      due to any reason beyond the reasonable control of the
                      Organiser, including but not limited to technical
                      difficulties, unauthorized intervention or fraud, the
                      Organiser reserves the right, in its sole discretion, to
                      the fullest extent permitted by law (a) to invalidate any
                      customer; or (b) subject to any written directions from a
                      regulatory authority, to modify, suspend, terminate or
                      cancel the promotion, as appropriate.
                    </p>
                    <p>
                      o The Organiser is not responsible for any problems or
                      technical malfunction of any telephone or network or
                      lines, servers or providers, computer equipment, software,
                      technical problems or traffic congestion on a mobile
                      network, or any combination thereof, or any other
                      technical failures including any damage to Participant's
                      or any other person's mobile handset or computer related
                      to, or resulting from, participation in this Promotion or
                      the downloading of any materials related to this
                      Promotion.
                    </p>
                    <p>
                      o If for any reason this Promotion is not capable of
                      running as planned because of infection by computer virus,
                      bugs, tampering, unauthorized intervention, technical
                      failures or any other causes beyond the reasonable control
                      of the Agency which corrupt or affect the administration,
                      security, fairness, integrity or proper conduct of this
                      Promotion, the Agency or CCIPL reserves the right in its
                      sole discretion to cancel, terminate, modify or suspend
                      the Promotion, subject to any written directions made
                      under applicable State or Territory legislation.
                    </p>
                    <p>
                      o Caution: Any attempt to deliberately damage the
                      Promotion Platform or the information on the Promotion
                      Platform, to cause malicious damage or interference with
                      the normal functioning of the Promotion Platform, or to
                      otherwise undermine the legitimate operation of this
                      Promotion may be a violation of criminal and civil laws
                      and should such an attempt be made, whether successful or
                      not, the Agency reserves the right to seek damages to the
                      fullest extent permitted by law. If the Agency suffers
                      loss or incurs any costs in connection with any breach of
                      these Terms or any other legal obligation by a
                      Participant, the Participant agrees to indemnify the
                      Agency for those losses, damages, and costs.
                    </p>
                    <p>
                      o The Agency/Logistic Partner, its clients, agents, and
                      distributors accept no responsibility, financial or
                      otherwise for the misuse of the Prize(s)and are not liable
                      for any personal loss or injury and cannot be held
                      responsible for any disagreement concerning quality/
                      availability of the Prize(s).
                    </p>
                    <p>
                      o The Agency/the Logistic Partner, its clients, agents,
                      and distributors cannot replace any lost, stolen or
                      damaged Prize(s) and reserve the right to withdraw or
                      amend any details and/or prices without notice.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>13.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Release and Limitations of Liability</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      (i) By entering the Promotion, the Participants hereby
                      release from and agree to indemnify CCIPL, and/ or any of
                      their respective officers/employees from and against all
                      liability, cost, loss or expense arising out of acceptance
                      of the Prize or participation in the Promotion including
                      (but not limited to) personal injury and damage to
                      property and whether direct, indirect, consequential,
                      foreseeable, due to some negligent act or omission, or
                      otherwise.
                    </p>
                    <p>
                      (ii) CCIPL accept no liability, whether jointly or
                      severally, for any errors or omissions, whether on behalf
                      of themselves or third parties in relation to the Prizes.
                      CCIPL, and any of their respective parent companies,
                      subsidiaries, affiliates, directors, officers,
                      professional advisors, employees and agencies will not be
                      responsible for any late, lost, misrouted, or distorted or
                      damaged transmissions or entries.
                    </p>
                    <p>
                      (iii) The Participant(s) shall be solely responsible for
                      any consequences which may arise due to their
                      participation in the Promotion by conducting an illegal
                      act. Participant(s) also undertakes to indemnify CCIPL and
                      their respective officers, directors, employees and agents
                      on the happening of such an event (including without
                      limitation cost of attorney, legal charges etc.) on full
                      indemnity basis for any loss/damage suffered by CCIPL on
                      account of such act on the part of the Participant.
                      Participant(s) hereby agree to indemnify, defend and hold
                      harmless CCIPL in case of any loss or liability (including
                      but not limited to liabilities, judgments, damages,
                      losses, fines and penalties, claims, costs and expenses
                      such as attorneys’ fees and expenses) or any other loss
                      associated with, arising out of or incidental to their
                      ineligibility to participate, any untoward, rash or
                      negligent act on their part, or non-compliance or alleged
                      non-compliance with these Terms, any other rules,
                      regulations, directives (whether written or verbal) issued
                      by CCIPL from time to time, during the Promotion.
                    </p>
                    <p>
                      (iv) To the fullest extent permitted by law, in no event
                      will CCIPL or any of its officers, servants, employees,
                      representatives and/or agents (including without
                      limitation, any third party service providers that CCIPL
                      may engage for purposes of the Promotion), be liable for
                      any loss or damages (including, without limitation loss of
                      income, profits or goodwill, indirect, incidental,
                      consequential, exemplary, punitive or special damages of
                      any party including third parties) howsoever arising
                      whether in contract, tort, negligence or otherwise, in
                      connection with the Promotion and/or the Promotion Prizes,
                      even if CCIPL has been advised of the possibility of such
                      damages in advance, and all such damages are expressly
                      excluded. The Participant shall indemnify, defend, and
                      hold CCIPL harmless in the event of there being any third
                      party/entity/organization claims arising from or related
                      to his/her participation in the Promotion. In no event
                      shall CCIPL and be liable to any Participant for acts or
                      omissions arising out of or related to the Promotion or
                      his/her participation in the Promotion.
                    </p>
                    <p>
                      (v) In consideration of CCIPL allowing the Participant(s)
                      to take part in the Promotion, to the maximum extent
                      permitted by law, the Participant(s) waive and release
                      each and every right or claim, all actions, causes of
                      actions (present or future) each of them has or may have
                      against CCIPL, its respective agents, directors, officers,
                      business associates, group companies, sponsors, employees,
                      or representatives for all and any injuries, accidents, or
                      mishaps (whether known or unknown) or (whether anticipated
                      or unanticipated) arising out of the Promotion or related
                      to the Promotion or the Prizes of the Promotion.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="56" valign="top">
                    <p>
                      <strong>14.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="85" valign="top">
                    <p>
                      <strong>Dispute</strong>
                    </p>
                  </td>
                  <td width="361" valign="top">
                    <p>
                      (i) The courts of competent jurisdiction at Gurgaon shall
                      have exclusive jurisdiction to determine any and all
                      disputes arising out of, or in connection with, the
                      Promotion.
                    </p>
                    <p>
                      (ii) Participation in the Promotion is unauthorized in any
                      jurisdiction that does not give effect to all provisions
                      of these Terms, including without limitation, this clause.
                    </p>
                    <p>
                      (iii) Further all issues and questions concerning the
                      construction, validity, interpretation and enforceability
                      of these Terms, or the rights and obligations of the
                      Participants and/or CCIPL and/or partners of this
                      Promotion, shall be governed and construed in accordance
                      with the laws of the Republic of India.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3 className="page-title" align="center">
            Terms and Conditions
          </h3>
          <h3 className="page-sub-title" align="center">
            <strong>Thums Up® ThunderWheels 2025 Promotion</strong>
          </h3>
          <h3 className="page-sub-title" align="center">
            <strong>
              (1<sup>st</sup> Aug to 30<sup>th</sup> Nov 2025)
            </strong>{" "}
            - Expired Promotion
            <strong></strong>
          </h3>
          <div align="center">
            <table border="1" cellspacing="0" cellpadding="0" width="669">
              <tbody>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>Clause</strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Title</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      <strong>Terms and Conditions</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>1.</strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>
                        Promotion Details, Concept and Participation
                      </strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      <strong>Thums Up® ThunderWheels Promotion</strong>
                      (“<strong>Promotion</strong>”) is a consumer promotion
                      organised by Coca-Cola India Private Limited (“
                      <strong>CCIPL</strong>”), wherein individuals, upon
                      scanning the QR Code on the Promotion Products (as defined
                      hereinbelow) can participate in and get a chance to win
                      Prize(s) (as defined in Clause 7) by registering on the
                      the official Thums Up® ThunderWheels WhatsApp channel
                      Platformand performing activities (detailed in Clause 6)
                      as provided post such registration, in accordance with the
                      terms and conditions mentioned herein. <strong></strong>
                    </p>
                    <p>
                      The Promotion shall be valid for the individuals residing
                      in India except for the state of Tamil Nadu
                      <strong>(“Promotion Territory”)</strong>and shall be
                      applicable on 250ml, 400ml,500ml, 600ml, 750ml, 1L, 1.25L,
                      1.5L, 2L, 2.25L
                      <strong>
                        Thums Up® PET packs (“Promotion Product(s)”).
                      </strong>
                      By participating in this Promotion, the Eligible Persons
                      as per Clause 5 (each a “<strong>Participant</strong>”)
                      accepts and agrees to abide by these terms and conditions
                      of the Promotion (“
                      <strong>Promotion</strong>
                      <strong>Terms</strong>”). It is hereby clarified that the
                      Participant may participate in the Promotion multiple
                      times, but he/she shall be eligible to win up to a maximum
                      of <strong>one (1) Bumper Prize</strong>
                      and two (2) Daily Prize(s) , per Mobile Number during the
                      Promotion Period.
                    </p>
                    <p>
                      The Promotion is advertised and promoted,
                      <em>inter alia</em>, through media including digital
                      media, point of sale materials, public announcements,
                      website, and other available media.
                    </p>
                    <p>
                      The Promotion is subject to all applicable central, state,
                      and local laws and regulations.
                    </p>
                    <p>
                      These Promotion terms and conditions (“
                      <strong>Terms</strong>”) will be hosted at {" "}
                      <a
                        style={{ textDecoration: "underline" }}
                        href="https://www.coke2home.com/thunderwheels"
                      >
                        https://www.coke2home.com/thunderwheels
                      </a>
                      ..
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>2.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>CCIPL and Partners</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      This Promotion is organised by CCIPL, having its corporate
                      office at 16th floor, One Horizon Center, Golf Course
                      Road, DFL Phase V, Sector 43, Gurgaon.
                    </p>
                    <p>
                      The operational part of the offer is managed by PREMIER
                      SALES PROMOTIONS PRIVATE LIMITED, having its registered
                      office at Mitra Towers, 4 <sup>th</sup> Floor, Kasturba
                      Road, Bangalore 560 001 (hereinafter referred to as “
                      <strong>Agency</strong>”).
                    </p>
                    <p>
                      The Bumper Prize can be collected by the Winner from Hero
                      MotoCorp Limited’s (“<strong>Hero</strong>”) nominated
                      Dealership (as defined in accordance with the Terms
                      herein. It is clarified that any manufacturing liability
                      and warranty on the Bumper Prize shall be governed by
                      applicable Hero warranty terms.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>3.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Deemed acceptance of terms and conditions</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      Entry and participation in this Promotion will be deemed
                      as an unconditional and an unequivocal acceptance of these
                      Terms, including any modifications, revisions, and
                      amendments thereto. The decisions of CCIPL shall be final
                      and binding on the Participants in all matters related to
                      the Promotion. Further, the Participants recognize that
                      these Terms may be modified by CCIPL from time to time
                      without any prior/public notice by posting the applicable
                      terms and conditions on the Promotion Platform. CCIPL also
                      reserves the right to cancel or terminate the Promotion at
                      any stage without assigning any reasons whatsoever.
                      Successfully entering the Promotion and winning a Prize is
                      subject to all requirements set forth herein.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>4.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Promotion Period</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      This Promotion will commence at 00:00:00 hrs Indian
                      Standard Time (“<strong>IST</strong>”) on {" "}
                      <strong>
                        1<sup>st</sup> August 2025 {" "}
                      </strong>
                      (“<strong>Start Date</strong>”) and will continue until{" "}
                      <strong>
                        30 <sup>th</sup> November 2025{" "}
                      </strong>
                      <strong></strong>11:59:59 pm IST (“
                      <strong>End Date</strong>”)
                      <strong>(“Promotion Period”)</strong>. Any entries
                      received outside the Promotion Periods shall not be
                      eligible for the Prize(s) applicable for that phase and
                      shall not be carried forward to any other promotional
                      scheme ahead.
                    </p>
                    <p>
                      Stock of The Coca-Cola Company Products without the
                      Promotion offer will also be available across India.
                    </p>
                    <p>
                      Further, certain stock of The Coca-Cola Company Products
                      containing the Promotion offer may be available before the
                      Promotion Period or may continue to be available even
                      after the Promotion Period. However, prospective
                      Participants understand and agree that they will not be
                      permitted to participate in the Promotion before
                      commencement of the Promotion Period and after the expiry
                      of the Promotion Period and further, agree not to raise
                      any claim or complaint against Hero, CCIPL, its affiliates
                      or its agents in this respect.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>5.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Eligibility</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      Subject to the criteria of Promotion Territory, entry and
                      participation in this Promotion is open to individuals who
                      satisfy each of the following criteria (“
                      <strong>Eligible Persons</strong>”):
                    </p>
                    <ol start="5" type="i">
                      <li>Must have attained 18 (eighteen) years of age.</li>
                      <li>
                        own a valid cellular GSM or CDMA phone connection and
                        internet connection that is accessible at all times.
                      </li>
                      <li>
                        bear a good moral character and have not been implicated
                        or named in any legal proceedings (either civil or
                        criminal).
                      </li>
                      <li>
                        are not management, employees, directors or contractors,
                        or the family of the management, employees, directors or
                        contractors of CCIPL, their related entities or other
                        agencies, firms or companies associated with or related
                        to the Promotion (including suppliers of Prizes).
                      </li>
                    </ol>
                    <p>
                      Please note that any entry received from states other than
                      the Promotion Territory shall be declared as null and void
                      and shall not be taken into consideration for determining
                      the Winners of the Prize.
                    </p>
                    <p>
                      For the sake of clarity, this Promotion is not open to
                      Non-Resident Indians (NRIs), Overseas Citizens of India
                      (OCIs) and Persons of Indian Origin (PIOs).
                    </p>
                    <p>
                      Eligible Persons participating or seeking to participate
                      in the Promotion shall individually be referred to as “
                      <strong>Participant</strong>” and collectively as “
                      <strong>Participants</strong>”.
                    </p>
                    <p>
                      If any Eligible Person has listed his/her phone numbers on
                      the National Do Not Call Registry (“
                      <strong>NDNC Registry</strong>”), he/she shall de-register
                      from the NDNC Registry prior to participating in the
                      Promotion, till the completion of the Promotion (including
                      availing of the Prize (if applicable) under the
                      Promotion). Such persons agree not to make any claim or
                      raise any complaint whatsoever against CCIPL in this
                      respect. Please note that persons intending to participate
                      in the Promotion who have not de-registered themselves
                      from the NDNC Registry shall also have no right to make
                      any claim or raise any complaints against CCIPL, if they
                      do or do not receive any call or SMS with respect to their
                      application, participation and all other matters
                      pertaining to the Promotion.
                    </p>
                    <p>
                      By participating in the Promotion, each Participant hereby
                      agrees to receive:
                    </p>
                    <p>
                      iii. details and information on this Promotion, on their
                      respective mobile phones, through SMS or voice calls,
                      during the entire tenure of the Promotion.
                    </p>
                    <p>
                      iv. updates and announcements concerning CCIPL’s products
                      and promotions, on their respective mobile phones (through
                      SMS or voice calls) and Email Ids.
                      <strong></strong>
                    </p>
                    <p>
                      <strong>(“Marketing Communication”)</strong>
                    </p>
                    <p>
                      The Participant may opt-out of receiving Marketing
                      Communication from CCIPL at any time by emailing or
                      calling, using the contact information listed below. In
                      such a request, the Participant must indicate that he/she
                      wishes to stop receiving Marketing Communication from
                      CCIPL.
                    </p>
                    <p>
                      Email:
                      <a href="mailto:indiahelpline@coca-cola.com">
                        indiahelpline@coca-cola.com
                      </a>
                    </p>
                    <p>Consumer Helpline: 1800-208-2653</p>
                    <p>Timings:</p>
                    <p>9:00am–9:00pm (Mon-Sat)</p>
                    <p>9:00am-6:00pm (Sun)</p>
                    <p>
                      The Participant hereby agrees that he/she has read and
                      understood the Privacy Policy mentioned on the Promotion
                      Platform and provides his/her unconditional consent to
                      collection of his/her personal information namely Name,
                      Mobile Number, Email ID, Address and Location. Further,
                      the Participant hereby provides his/her consent for
                      storage and processing of his/her personal information
                      collected for the purposes of sending communication
                      including but not limited to Marketing Communication.
                      <strong></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <strong>
                      <ol start="6" type="1">
                        <li></li>
                      </ol>
                    </strong>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Participating in the Promotion</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      The Campaign and Promotion can be accessed on the Platform
                      by following these steps:
                    </p>
                    <p>
                      1. Buy a <strong>Thums Up®</strong>
                      <strong>Promotion</strong>
                      Product.
                    </p>
                    <p>
                      2. Scan the QR code on the Promotion Product to visit the
                      official Thums Up® ThunderWheels WhatsApp channel.
                    </p>
                    <p>
                      3. Press ‘Send’ on the autotyped message on the Thums Up®
                      WhatsApp channel to begin the conversation with the Thums
                      Up WhatsApp bot. A link to these Terms &amp; Conditions
                      and our Privacy Policy will be made available here as
                      well. By continuing in the conversation, Participants are
                      deemed to have consented to the Terms and Conditions, and
                      to the collection, storage and processing of their
                      personal information as per the Privacy Policy provided
                      therein.
                    </p>
                    <p>
                      4. Engage with the WhatsApp chatbot, add unique code from
                      behind the label of the promotion product to get a chance
                      to win the Prize(s)
                    </p>
                    <p>
                      5. Upon entering the unique code, the Participant will be
                      entered into a computerised random draw to win the
                      Prize(s) as outlined in Clause 7
                    </p>
                    <p>
                      6. If you are winner of the Daily Prize(s), you will be
                      instantly notified on the Platform on the win, along with
                      voucher code and instructions to redeem the Prize.
                    </p>
                    <p>
                      7. Additional terms and conditions may apply on the
                      redemption platforms.
                    </p>
                    <p>
                      8. If you are a winner of the Bumper Prize, you will be
                      instantly notified on Platform on the win.
                    </p>
                    <p>
                      a. You will be required to fill out a Claim Form to
                      provide, including but not limited to, your shipping
                      address
                    </p>
                    <p>
                      <u>Other terms &amp; conditions:</u>
                    </p>
                    <p>
                      9.
                      <strong>
                        Daily Prizes must be redeemed latest within 2 months of
                        winning the prize
                      </strong>
                      <strong>(“Digital Redemption Window”)</strong> using a
                      claim form available on the Promotion Platform. Any Prize
                      not claimed by the Redemption Window will be forfeited.
                    </p>
                    <p>
                      10. Bumper Prize <strong>must be claimed</strong> using a
                      claim form available on the Platform within 72 hours of
                      winning the Prize (“Claim Window”) to avoid forfeiting.
                    </p>
                    <p>
                      11. All earned prizes will be visible under ‘My Wins’
                      Section on the Promotion WhatsApp Chatbot.
                    </p>
                    <p>
                      12. Participants will also be notified via SMS/ WhatsApp
                      of the details of the Prize(s) won &amp; instructions on
                      how to redeem their Prize(s).
                    </p>
                    <p>
                      13. Any forfeiture exercised by will be binding and final
                      on the Participants.
                    </p>
                    <p>
                      14. Entry by proxy is not permitted. Participants can only
                      enter in their own name. The Participants shall be solely
                      responsible for any local calls / STD charges applicable
                      by their telecom service providers on the Promotion
                      entries.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <strong>
                      <ol start="7" type="1">
                        <li></li>
                      </ol>
                    </strong>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Prizes and Winners</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      During the Promotion Period, Participants on the basis of
                      valid participation as per the Terms of Clause 6, shall be
                      eligible to win the following prize(s) ( “
                      <strong>Prize(s)</strong>”):
                    </p>
                    <p>
                      <strong>Bumper Prize</strong>
                    </p>
                    <p>1. A Special Edition Hero Mavrick 440 bike</p>
                    <p>Or</p>
                    <p>2. A Hero Xtreme 250R</p>
                    <p>
                      <strong>Daily Prize(s):</strong>
                    </p>
                    <p>
                      PhonePe Vouchers worth up to Rs. 50 to be redeemed on
                      PhonePe app
                    </p>
                    <p>
                      The winners of the Prize(s) (each a “
                      <strong>Winner</strong>”) may access details of their
                      Prize(s) under the My Wins section on the WhatsApp
                      Chatbot. It is hereby clarified that, the Participant can
                      participate in the Promotion multiple times during the
                      Promotion Period, but each Participant will be eligible to
                      win up to a maximum of
                      <strong>
                        one Bumper Prize &amp; two (2) Daily prize(s) per Mobile
                        Number during the Promotion Period.
                      </strong>
                    </p>
                    <p>
                      <strong>Additional Terms for the Bumper Prize:</strong>
                    </p>
                    <p>
                      1. The Winners of the Bumper Prize, upon submission of
                      valid Claim Form on the Promotion Platform, shall be
                      contacted by the authorised Agency of CCIPL via email,
                      confirming the Winner and their Bumper Prize.
                    </p>
                    <p>
                      2. The Winner is required to show said email confirming
                      his/her winnings to the Dealership (as defined herein
                      below) to claim the Bumper Prize, subject to the below
                      terms.
                    </p>
                    <p>
                      3. The Winner, subject to submission of valid documents,
                      as needed, and communicated to the Winner by CCIPL/Agency
                      , collect the Bumper Prize from the select HERO dealership
                      as nominated by Hero (and communicated to the Winner by
                      the Agency) (“<strong>Dealership</strong>”) between 1{" "}
                      <sup>st</sup> October 2025 and 30
                      <sup>th</sup>
                      June 2026 (“<strong>Hero Bike Redemption Window</strong>
                      ”).
                    </p>
                    <p>
                      4. No claim for a Bumper Prize may be entertained by
                      CCIPL/Hero outside the Redemption Window or when all
                      requested documents are not submitted.
                    </p>
                    <p>
                      5. It is hereby clarified that the Dealership may not be
                      in the same city where Winner is residing and in the event
                      the Dealership is in a different city, neither Agency,
                      Hero nor CCIPL shall be responsible for undertaking any
                      travel and/or transportation cost for the Winner to travel
                      to or from to such Dealership, or for the transport of the
                      Bumper Prize.
                    </p>
                    <p>
                      6. The Winner shall be solely responsible for making any
                      payments on the Bumper Prize, including but not limited to
                      road tax, insurance, registration, pollution upon transfer
                      of ownership and passion in the Bumper Prize from Hero to
                      the Winner.
                    </p>
                    <p>
                      7. Any requirements of servicing of the Bumper Prize,
                      shall lie with Hero as per its standard warranty terms as
                      applicable to the Special Edition Hero Mavrick 440 bike
                      and Hero Xtreme 250R. CCIPL shall not be liable for the
                      same.
                    </p>
                    <p>
                      8. The delivery of the Bumper Prize to the Winner shall be
                      subject to Hero terms and privacy policy as available on
                      Hero’s website; submission of relevant documents; other
                      payments as reflected above in Clause 9 and; applicable
                      laws.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <strong>
                      <ol start="8" type="1">
                        <li></li>
                      </ol>
                    </strong>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Selecting and contacting Eligible Winners</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      (i)- The Participants will be eligible to receive the
                      Prize subject to the Terms detailed herein.
                    </p>
                    <p>
                      (ii)- Winners will be selected through a computerized
                      random selection from the pool of valid submissions/
                      entries, in accordance with these Terms &amp; Conditions.
                    </p>
                    <p>
                      (iii)- The Participants acknowledge not to raise any claim
                      or complaint against CCIPL due to technical failure or any
                      other causes beyond the control of CCIPL.
                    </p>
                    <p>
                      (iv)- Prizes once awarded cannot be replaced under any
                      circumstances.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <strong>
                      <ol start="9" type="1">
                        <li></li>
                      </ol>
                    </strong>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Publicity</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      The Participants undertake and irrevocably and
                      unconditionally permit CCIPL/Hero to cover the Promotion
                      through various media including newspapers, radio,
                      television including news and other channels, internet,
                      point of sale materials, etc., and shall not raise any
                      objection, protest, or demur whatsoever to such coverage
                      or in this regard. Further, the Participants also
                      understand and agree that their responses may be
                      publicised as part of this Promotion.
                    </p>
                    <p>
                      The Winners must, at the request of CCIPL/Hero,
                      participate in all promotional activity (such as publicity
                      and photography) surrounding the winning of the Prize,
                      free of charge, and they consent to CCIPL/Hero using their
                      name and image in all promotional materials.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <strong>
                      <ol start="10" type="1">
                        <li></li>
                      </ol>
                    </strong>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Intellectual Property</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      All right, title, and interest, including but not limited
                      to the Intellectual Property Rights, in the promotional
                      material(s), and in any and all responses received, or
                      other materials created during or for the Promotion, as a
                      part of the Promotion or otherwise, shall vest solely and
                      exclusively with CCIPL/Hero at all times. CCIPL/Hero or
                      any person or entity permitted by CCIPL/Hero in this
                      regard shall be entitled to use any information in
                      connection with the entry in any media for future
                      promotional, marketing, publicity and any other purpose,
                      without any permission and or payment to the Participant.
                      CCIPL/Hero may use the material in any medium in any
                      reasonable manner it sees fit. Copyright in any such
                      material remains the sole property of CCIPL/Hero. No
                      Participant shall upon participation gain any right title
                      or interest in the intellectual property of Hero.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>11.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>General Conditions</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      <strong>
                        <u>General Terms and Conditions:</u>
                      </strong>
                    </p>
                    <ul>
                      <li>
                        Each Participant represents and warrants that he/she is
                        legally competent to enter into binding contracts under
                        applicable laws. By taking part and/or entering into the
                        Promotion the Participant warrants that all information
                        and documents provided by Participant regarding
                        Participant's name, age, state, city, address, phone
                        number, etc., is true, correct, accurate and complete.
                      </li>
                      <li>
                        The decision of CCIPL or the Agency, as regards the
                        selection of winners and distribution of the prizes
                        shall be final, subject only to CCIPL ‘s approval. No
                        correspondence or any other claims whatsoever, in this
                        regard will be entertained.
                      </li>
                      <li>
                        No queries, claims, dispute, complaints or grievances
                        shall be entertained by CCIPL and the Agency after 60
                        days from the date of the closure of the Promotion.
                      </li>
                      <li>
                        The prize cannot be exchanged and is not transferable
                        and cannot be converted into cash.
                      </li>
                      <li>
                        The Agency shall provide the prize on an "as-is basis"
                        and without any warranty or guarantee concerning the
                        quality, suitability or comfort, and CCIPL and/or its
                        associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever.
                      </li>
                      <li>
                        CCIPL reserves the right to change, defer, alter or
                        cancel this Promotion in part or full, or change any or
                        all of the terms and conditions that are applicable,
                        without giving prior intimation/notice of any kind and
                        will not be liable for any consequential losses/damages.
                        Any decision of CCIPL in this regard and in general with
                        respect to this Promotion and the terms and conditions
                        thereto shall be final, binding and non-Offer able.
                      </li>
                      <li>
                        Nothing contained herein amounts to a commitment or
                        representation by CCIPL to conduct further Promotion.
                      </li>
                      <li>
                        CCIPL reserves the right to change any details of the
                        Promotion, including but not limited to amending these
                        terms and conditions, the type of Promotion, submission
                        mechanism, eligibility criteria, term of the Promotion,
                        and the prizes for the Promotion. CCIPL reserves the
                        right to amend, temporarily suspend or withdraw the
                        Promotion in its absolute discretion provided that CCIPL
                        shall not exercise this right unreasonably.
                      </li>
                      <li>
                        CCIPL shall not be liable to award/provide the prize(s)
                        and/or declare the winners of the prizes of the
                        Promotion due to any cause beyond its reasonable control
                        or foresight, including but not limited to, act of god,
                        insurrection or civil disorder, religious strife, war or
                        military operations, terrorist act, partial or total
                        strikes, either internal or external, lock-out,
                        epidemic, blockage of means of transport or of supplies,
                        national or local emergency, earthquake, fire, storm,
                        flood, water damage, governmental, regulatory or legal
                        restrictions, acts or omissions of persons for whom
                        CCIPL is not responsible.
                      </li>
                      <li>
                        The decision of CCIPL shall be final in all regards and
                        no communication shall be entertained in this regard.
                        None of the provisions of these Terms and Conditions
                        shall be deemed to constitute a partnership or agency
                        between any Participant and CCIPL and the Participant
                        shall not have the authority to bind CCIPL in any manner
                        whatsoever.
                      </li>
                      <li>
                        CCIPL or any of its respective
                        officers/employees/directors shall not be responsible
                        for delayed, lost, mutilated, corrupted or illegible
                        documents etc.
                      </li>
                      <li>
                        CCIPL or the Agency shall not be liable to perform any
                        of its/their respective obligations under the Promotion
                        or in respect of the prize where it is unable to do so
                        as a result of circumstances beyond its/their control in
                        the nature of fire, explosions, natural calamities,
                        state emergency, riots, or any other Force Majeure
                        condition, etc., and shall not be liable to compensate
                        the Participant in these circumstances.
                      </li>
                      <li>
                        CCIPL or the Agency shall not be accountable/liable for
                        any disruptions/stoppages/interruptions or cancellation
                        of the Promotion due to any government restrictions.
                      </li>
                      <li>
                        Failure to exercise or delay in exercising a right or
                        remedy provided hereunder or by law does not constitute
                        a waiver of the right or remedy or waiver of other
                        rights or remedies on the part of CCIPL or the Agency.
                      </li>
                      <li>
                        CCIPL or the Agency accepts no responsibility for late,
                        lost, incomplete, incorrectly submitted, delayed,
                        illegible, corrupted or misdirected entries, loss of
                        SMS, loss of internet connectivity, unique codes,
                        documents, demand drafts, claims or correspondence
                        whether due to error, omission, alteration, tampering,
                        unauthorized data hacking, deletion, theft, destruction,
                        virus attack, transmission interruption, communications
                        failure, hardware failure or otherwise. CCIPL or the
                        Agency shall not be liable for any consequences of user
                        error including (without limitation) costs incurred.
                      </li>
                      <li>
                        If a Participant is dissatisfied with the Promotion or
                        the Promotion rules and/or any content or any
                        requirements of the Promotion form, the materials
                        available related thereto, or with these terms and
                        conditions, his/her sole and exclusive remedy is to not
                        participate in the Promotion.
                      </li>
                      <li>
                        If a person chooses to access the Promotion Platform
                        from outside India, he/she shall do so on his/her own
                        initiative and shall be responsible for compliance with
                        applicable local laws of the country.
                      </li>
                      <li>
                        The operational part of the scheme like redemption of
                        prize &amp; dispatches shall be managed by the Agency;
                        However, promotional product will be distributed through
                        CCIPL Distributor/dealer.
                      </li>
                      <li>
                        The participation in the Promotion is purely voluntary
                        and the same shall be construed as an acceptance of the
                        terms and conditions stipulated herein.
                      </li>
                      <li>Release and Limitations of Liability:</li>
                    </ul>
                    <p>
                      (i) CCIPL and the Agency shall under no circumstances be
                      liable, whether jointly or severally, for any loss or
                      damage suffered or sustained (including but not limited to
                      consequential loss), including for personal injury or
                      property damage suffered or sustained, as a result of
                      acceptance of any prize.
                    </p>
                    <p>
                      (ii) By entering the Promotion, the Participant hereby
                      releases from and agrees to indemnify CCIPL, and/ or any
                      of its respective officers/employees from and against all
                      liability, cost, loss or expense arising out of acceptance
                      of the prize or participation in the Promotion including
                      (but not limited to) personal injury and damage to
                      property and whether direct, indirect, consequential,
                      foreseeable, due to some negligent act or omission, or
                      otherwise.
                    </p>
                    <p>
                      (iii) CCIPL and the Agency accept no liability, whether
                      jointly or severally, for any errors or omissions, whether
                      on behalf of itself, Agency or third parties in relation
                      to the prizes.
                    </p>
                    <p>
                      (iv) The Participant shall be solely responsible for any
                      consequences which may arise due to his/her participation
                      in the Promotion by conducting an illegal act. Participant
                      also undertakes to indemnify CCIPL and/or the Agency and
                      their respective officers, directors, employees and agents
                      on the happening of such an event (including without
                      limitation cost of attorney, legal charges etc.) on full
                      indemnity basis for any loss/damage suffered by CCIPL or
                      the Agency on account of such act on the part of the
                      Participant.
                    </p>
                    <p>
                      (v) In consideration of CCIPL allowing the Participant(s)
                      to take part in the Promotion , to the maximum extent
                      permitted by law, the Participant(s) waive and release
                      each and every right or claim, all actions, causes of
                      actions (present or future) each of them has or may have
                      against CCIPL , its respective agents, directors,
                      officers, business associates, group companies, sponsors,
                      employees, or representatives for all and any injuries,
                      accidents, or mishaps (whether known or unknown) or
                      (whether anticipated or unanticipated) arising out of the
                      Promotion or related to the Promotion or the prize of the
                      Promotion.
                    </p>
                    <p>
                      (vi) CCIPL reserve the right and discretion to disqualify
                      any participant from participating and further reserves
                      the right to rescind any Winner’s travel, stay or event
                      tickets- partially or fully in the event of any
                      misconduct, including but not limited to, misbehavior,
                      falsification of any information, inappropriate behaviour
                      with Agency and/or staff and security personnel, threats,
                      or statements offensive to TCCC, its Brands or anything
                      that might be construed as offensive , both in India and
                      West Indies. It is further clarified that neither CCIPL
                      nor the Agency shall be liable to indemnify the
                      Participant or Winner in any form with respect to the
                      same.
                    </p>
                    <ul>
                      <li>Additional General Terms and Conditions</li>
                    </ul>
                    <p>
                      o This Promotion is not available to employees, of CCIPL
                      and the Agency, its clients or agencies and their
                      immediate families.
                    </p>
                    <p>
                      o Any costs associated with entering the Promotion,
                      including accessing the Promotion Platform, are the
                      responsibility of each Participant. Also, regular call and
                      message rates will apply as per the consumer telecom
                      operator in their respective circles.
                    </p>
                    <p>
                      o The Agency is acting as an executing agency for this
                      Promotion and holds no legal and financial liability on
                      unclaimed Prize (s), incentives, etc. beyond the
                      applicable period of the Promotion.
                    </p>
                    <p>
                      o This Promotion is subject to promotional availability
                      and government regulations.
                    </p>
                    <p>
                      o The Agency &amp; CCIPL reserves the right to change the
                      terms and conditions of this scheme, including extending,
                      withdrawing, or discontinuing the same without notice,
                      without assigning any reason, at their sole discretion and
                      without any liability.
                    </p>
                    <p>
                      o If this promotion is interfered with in any way or is
                      not capable of being conducted as reasonably anticipated
                      due to any reason beyond the reasonable control of the
                      Agency, including but not limited to technical
                      difficulties, unauthorized intervention or fraud, the
                      Agency reserves the right, in its sole discretion, to the
                      fullest extent permitted by law (a) to invalidate any
                      customer; or (b) subject to any written directions from a
                      regulatory authority, to modify, suspend, terminate or
                      cancel the promotion, as appropriate.
                    </p>
                    <p>
                      o The Agency or CCIPL is not responsible for any problems
                      or technical malfunction of any telephone or network or
                      lines, servers or providers, computer equipment, software,
                      technical problems or traffic congestion on a mobile
                      network, or any combination thereof, or any other
                      technical failures including any damage to Participant's
                      or any other person's mobile handset or computer related
                      to, or resulting from, participation in this Promotion or
                      the downloading of any materials related to this Promotion
                    </p>
                    <p>
                      o If for any reason this Promotion is not capable of
                      running as planned because of infection by computer virus,
                      bugs, tampering, unauthorized intervention, technical
                      failures or any other causes beyond the reasonable control
                      of the Agency which corrupt or affect the administration,
                      security, fairness, integrity or proper conduct of this
                      Promotion, the Agency or CCIPL reserves the right in its
                      sole discretion to cancel, terminate, modify or suspend
                      the Promotion, subject to any written directions made
                      under applicable State or Territory legislation.
                    </p>
                    <p>
                      o Caution: Any attempt to deliberately damage the
                      Promotion Platform or the information on the Promotion
                      Platform, to cause malicious damage or interference with
                      the normal functioning of the Promotion Platform, or to
                      otherwise undermine the legitimate operation of this
                      Promotion may be a violation of criminal and civil laws
                      and should such an attempt be made, whether successful or
                      not, the Agency reserves the right to seek damages to the
                      fullest extent permitted by law. If the Agency suffers
                      loss or incurs any costs in connection with any breach of
                      these Terms or any other legal obligation by a
                      Participant, the Participant agrees to indemnify the
                      Agency for those losses, damages, and costs.
                    </p>
                    <p>
                      o CCIPL, Agency, its clients, agents, and distributors
                      accept no responsibility, financial or otherwise for the
                      misuse of the Prize(s)and are not liable for any personal
                      loss or injury and cannot be held responsible for any
                      disagreement concerning quality/ availability of the
                      Prize(s).
                    </p>
                    <p>
                      o CCIPL does not endorse the quality of any of the
                      products or services being offered by the Agency or by the
                      Promotion partner. Any complaints or queries pertaining to
                      the same would have to be taken up directly with the
                      Agency marketing of such a product or service.
                    </p>
                    <p>
                      o The Agency, its clients, agents, and distributors cannot
                      replace any lost, stolen or damaged Prize(s) and reserve
                      the right to withdraw or amend any details and/or prices
                      without notice.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>12.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Release and Limitations of Liability</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      (vi) By entering the Promotion, the Participants hereby
                      release from and agree to indemnify CCIPL, and/ or any of
                      their respective officers/employees from and against all
                      liability, cost, loss or expense arising out of acceptance
                      of the Prize or participation in the Promotion including
                      (but not limited to) personal injury and damage to
                      property and whether direct, indirect, consequential,
                      foreseeable, due to some negligent act or omission, or
                      otherwise.
                    </p>
                    <p>
                      Further, by participating in this Promotions, the
                      Participant agree and acknowledge that Hero is not
                      responsible for organizing the Promotion and therefore, no
                      claim in this regard shall be raised against Hero or any
                      of its founders, promoters, directors, employees or
                      officers. Hero is not liable in any manner whatsoever,
                      with regard to the organization of the Promotion or any
                      participation therein/disqualification therefrom.
                    </p>
                    <p>
                      (vii) CCIPL accept no liability, whether jointly or
                      severally, for any errors or omissions, whether on behalf
                      of themselves or third parties in relation to the Prizes.
                      CCIPL, and any of their respective parent companies,
                      subsidiaries, affiliates, directors, officers,
                      professional advisors, employees and agencies will not be
                      responsible for any late, lost, misrouted, or distorted or
                      damaged transmissions or entries.
                    </p>
                    <p>
                      (viii) The Participant(s) shall be solely responsible for
                      any consequences which may arise due to their
                      participation in the Promotion by conducting an illegal
                      act. Participant(s) also undertakes to indemnify CCIPL and
                      their respective officers, directors, employees and agents
                      on the happening of such an event (including without
                      limitation cost of attorney, legal charges etc.) on full
                      indemnity basis for any loss/damage suffered by CCIPL on
                      account of such act on the part of the Participant.
                      Participant(s) hereby agree to indemnify, defend and hold
                      harmless CCIPL in case of any loss or liability (including
                      but not limited to liabilities, judgments, damages,
                      losses, fines and penalties, claims, costs and expenses
                      such as attorneys’ fees and expenses) or any other loss
                      associated with, arising out of or incidental to their
                      ineligibility to participate, any untoward, rash or
                      negligent act on their part, or non-compliance or alleged
                      non-compliance with these Terms, any other rules,
                      regulations, directives (whether written or verbal) issued
                      by CCIPL from time to time, during the Promotion.
                    </p>
                    <p>
                      (ix) To the fullest extent permitted by law, in no event
                      will CCIPL or any of its officers, servants, employees,
                      representatives and/or agents (including without
                      limitation, any third party service providers that CCIPL
                      may engage for purposes of the Promotion), be liable for
                      any loss or damages (including, without limitation loss of
                      income, profits or goodwill, indirect, incidental,
                      consequential, exemplary, punitive or special damages of
                      any party including third parties) howsoever arising
                      whether in contract, tort, negligence or otherwise, in
                      connection with the Promotion and/or the Promotion Prizes,
                      even if CCIPL has been advised of the possibility of such
                      damages in advance, and all such damages are expressly
                      excluded. The Participant shall indemnify, defend, and
                      hold CCIPL harmless in the event of there being any third
                      party/entity/organization claims arising from or related
                      to his/her participation in the Promotion. In no event
                      shall CCIPL and be liable to any Participant for acts or
                      omissions arising out of or related to the Promotion or
                      his/her participation in the Promotion.
                    </p>
                    <p>
                      (x) In consideration of CCIPL allowing the Participant(s)
                      to take part in the Promotion, to the maximum extent
                      permitted by law, the Participant(s) waive and release
                      each and every right or claim, all actions, causes of
                      actions (present or future) each of them has or may have
                      against CCIPL, its respective agents, directors, officers,
                      business associates, group companies, sponsors, employees,
                      or representatives for all and any injuries, accidents, or
                      mishaps (whether known or unknown) or (whether anticipated
                      or unanticipated) arising out of the Promotion or related
                      to the Promotion or the Prizes of the Promotion.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="61" valign="top">
                    <p>
                      <strong>13.</strong> <strong></strong>
                    </p>
                  </td>
                  <td width="70" valign="top">
                    <p>
                      <strong>Dispute</strong>
                    </p>
                  </td>
                  <td width="371" valign="top">
                    <p>
                      (iv) The courts of competent jurisdiction at Gurgaon shall
                      have exclusive jurisdiction to determine any and all
                      disputes arising out of, or in connection with, the
                      Promotion.
                    </p>
                    <p>
                      (v) Participation in the Promotion is unauthorized in any
                      jurisdiction that does not give effect to all provisions
                      of these Terms, including without limitation, this clause.
                    </p>
                    <p>
                      (vi) Further all issues and questions concerning the
                      construction, validity, interpretation and enforceability
                      of these Terms, or the rights and obligations of the
                      Participants and/or CCIPL and/or partners of this
                      Promotion, shall be governed and construed in accordance
                      with the laws of the Republic of India.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsJune_19;
